
export const IS_MOBILE_CHECK = "IS_MOBILE_CHECK";
export const SELECTED_QUOTE = "SELECTED_QUOTE";
export const SELECTED_TAB = "SELECTED_TAB";
export const MENU_FETCH_SUCCESS = "MENU_FETCH_SUCCES";
export const IS_LOADING = "IS_LOADING";
export const DEFAULT_SELECTED_NODE = "DEFAULT_SELECTED_NODE";
export const DEFAULT_SELECTED_SUBCAT = "DEFAULT_SELECTED_SUBCAT";

export const LOGIN_SUCCESS = "LOGIN_SUCCESS";
export const LOGIN_FAILURE = "LOGIN_FAILURE";
export const LOGOUT_SUCCESS = "LOGOUT_SUCCESS";
export const LOGOUT_FAILURE = "LOGOUT_FAILURE";
export const UPDATE_LOGIN = "UPDATE_LOGIN";
